var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Editor',{ref:"toastuiEditor",attrs:{"options":_vm.editorConfig,"initial-edit-type":"wysiwyg","preview-style":"tab"},on:{"change":_vm.onEditorChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }